<div class="about-page">
  <header class="page-hero">
    <h1>Desarrollo web y software con claridad para medianas empresas.</h1>
    <p class="hero-lead">
      ATSIestudio es un estudio de Segovia centrado en crear y actualizar la presencia online de
      empresas, además de desarrollar aplicaciones y herramientas internas para su gestión.
    </p>
    <a class="button button-primary" routerLink="/contacto">Cuéntanos tu proyecto</a>
  </header>

  <section class="purpose" aria-labelledby="purpose-title">
    <div class="section-heading">
      <h2 id="purpose-title">Hacer comprensibles proyectos que pueden parecer complejos.</h2>
    </div>
    <div class="purpose-copy">
      <p>
        Una empresa no debería necesitar dominar la tecnología para tomar buenas decisiones sobre su
        web o sus herramientas digitales.
      </p>
      <p>
        El trabajo de ATSIestudio parte del contexto del negocio: entender el problema, ordenar las
        necesidades y explicar la solución antes de desarrollarla.
      </p>
    </div>
  </section>

  <section aria-labelledby="principles-title">
    <div class="section-heading">
      <h2 id="principles-title">Profesionalidad que se demuestra en la forma de trabajar.</h2>
      <p>Estos principios orientan cómo planteamos y comunicamos cada proyecto.</p>
    </div>
    <ol class="principle-list">
      <li>
        <span>01</span>
        <div>
          <h3>Claridad</h3>
          <p>Explicar objetivos, alcance y decisiones técnicas con un lenguaje comprensible.</p>
        </div>
      </li>
      <li>
        <span>02</span>
        <div>
          <h3>Proporción</h3>
          <p>Proponer la tecnología que responde a la necesidad, sin complejidad gratuita.</p>
        </div>
      </li>
      <li>
        <span>03</span>
        <div>
          <h3>Orden</h3>
          <p>Convertir una necesidad abierta en prioridades y siguientes pasos identificables.</p>
        </div>
      </li>
      <li>
        <span>04</span>
        <div>
          <h3>Cercanía</h3>
          <p>
            Mantener la conversación centrada en las personas y en el funcionamiento del negocio.
          </p>
        </div>
      </li>
    </ol>
  </section>

  <section class="location" aria-labelledby="location-title">
    <div class="location-heading">
      <h2 id="location-title">Un estudio local con alcance nacional.</h2>
    </div>
    <div>
      <p>
        ATSIestudio está en Segovia y trabaja con empresas de toda España. El objetivo es el mismo:
        que cada cliente pueda entender qué se propone, por qué y cuál es el siguiente paso.
      </p>
      <p>
        Para empresas que buscan un proveedor local, explicamos el enfoque de nuestro
        <a routerLink="/desarrollo-web-segovia">servicio de desarrollo web en Segovia</a>.
      </p>
      <a class="text-link" routerLink="/como-trabajamos">Conoce cómo trabajamos</a>
    </div>
  </section>

  <section class="collaboration" aria-labelledby="collaboration-title">
    <div class="section-heading">
      <h2 id="collaboration-title">
        El conocimiento del negocio y el desarrollo técnico, en la misma conversación.
      </h2>
    </div>
    <div class="collaboration-grid">
      <article>
        <span>La empresa aporta</span>
        <h3>Contexto, objetivos y prioridades.</h3>
        <p>La información necesaria para comprender qué debe resolver el proyecto.</p>
      </article>
      <article>
        <span>ATSIestudio aporta</span>
        <h3>Análisis, estructura y desarrollo.</h3>
        <p>La capacidad técnica para convertir esa necesidad en una propuesta entendible.</p>
      </article>
    </div>
  </section>

  <section class="about-cta" aria-labelledby="about-cta-title">
    <h2 id="about-cta-title">¿Tienes un proyecto digital en mente?</h2>
    <p>Cuéntanos qué necesita tu empresa y en qué punto te encuentras.</p>
    <a class="button button-primary" routerLink="/contacto">Empezar una conversación</a>
  </section>
</div>
